import Vue from "vue";
import VueRouter from "vue-router";
import ExpeditionsALERCE from "@/views/Expeditions/ALERCE2/Expeditions.vue";
import ExpeditionsXPO from "@/views/Expeditions/XPO2/Expeditions.vue";
import PostalCode from "@/views/PostalCode.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "PostalCode",
    component: PostalCode,
    props: route => ({
      token: route.query.token,
      uuid: route.query.uuid,
      lang: route.query.lang,
      tpvConfirm: route.query.tpvConfirm
    })
  },
  {
    path: "/expeditions/:token/:consigneePostalCode",
    name: "expeditions_ALERCE",
    component: ExpeditionsALERCE,
    meta: { organization: "ALERCE" }
  },
  {
    path: "/expeditions/:token/:consigneePostalCode",
    name: "expeditions_XPO",
    component: ExpeditionsXPO,
    props: route => ({
      uuid: route.query.uuid,
      lang: route.query.lang,
      tpvConfirm: route.query.tpvConfirm
    }),
    meta: { organization: "XPO" }
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeResolve(async (to, from, next) => {
  if (to.path.startsWith("/expeditions/")) {
    if (to.params.organization === undefined) {
      next({
        name: "PostalCode",
        query: {
          token: to.params.token,
          uuid: to.query.uuid,
          lang: to.query.lang
        }
      });
    }
  }
  next();
});

export default router;
